import React, { createContext, useContext, useEffect, useState } from "react";
import { getProducts } from "../api";
import { Product } from "../types";

interface ProductContextType {
  primaryProductId: string | null;
}

const ProductContext = createContext<ProductContextType>({ primaryProductId: null });

export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [primaryProductId, setPrimaryProductId] = useState<string | null>(null);

  useEffect(() => {
    getProducts()
      .then((products: Product[]) => {
        const target = products.find((p) => p.is_active) ?? products[0];
        if (target) setPrimaryProductId(target.id);
      })
      .catch(() => {});
  }, []);

  return (
    <ProductContext.Provider value={{ primaryProductId }}>
      {children}
    </ProductContext.Provider>
  );
};

export const usePrimaryProduct = (): ProductContextType => useContext(ProductContext);
